import dayjs from "dayjs"
import { DocumentData, QueryDocumentSnapshot } from "firebase/firestore"
import { Account, Record, RecordType } from "../Type"
import { timber_debug } from "../Timber"

export const getEmptyRecord = (
  account: Account | undefined,
  recordTypes: RecordType[]
): Record => {
  return {
    id: "",
    account: account ? account.name : "",
    date: dayjs().valueOf(),
    amount: 0,
    credit: true,
    recordType: recordTypes.length !== 0 ? recordTypes[0].name : "",
    recordTypeId: recordTypes.length !== 0 ? recordTypes[0].id : "",
    insertDate: dayjs().valueOf(),
    lastEditDate: dayjs().valueOf(),
    note: "",
    invoiceName: "",
    invoiceUri: "",
  }
}

export const getRecordFromDocSnapshot = (
  doc: QueryDocumentSnapshot<DocumentData, DocumentData>
): Record => {
  const rec = {
    id: doc.id,
    account: doc.data().account,
    date: doc.data().date,
    amount: doc.data().amount,
    credit: doc.data().credit,
    recordType: doc.data().recordType,
    recordTypeId: doc.data().recordTypeId,
    note: doc.data().note,
    invoiceName: doc.data().invoiceName,
    invoiceUri: doc.data().invoiceUri,
    insertDate: doc.data().insertDate,
    lastEditDate: doc.data().lastEditDate,
  }
  timber_debug(rec)
  return rec
}
